export default "__VITE_ASSET__57lDXKIt__"